import React from 'react';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import MobianDateTimeField from 'components/input/MobianDateTimeField/MobianDateTimeField';

const RenderDateTimeInputField = (field) => {
    return (
        <MobianDateTimeField
            { ...field }
            errorText={ field.meta.touched && field.meta.error }
            floatingLabelText={ field.label }
            hintText={ field.placeholder ? field.placeholder : field.label }
            id={ field.label }
            onBlur={ field.input.onBlur }
            style={ field.style }
        />
    );
};

RenderDateTimeInputField.propTypes = {
    field: PropTypes.object,
};

export default translate(RenderDateTimeInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderDateTimeInputField.js